import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import { useAssistanceData } from '../assistance/assistance-data';
import TracingPolicy from '../../common/assistance/tracing-policy/tracing-policy';
import { setProvider } from '../../../store/slices/generalSlice';
import storageService from '../../../services/storage.service';
import useAssistance from '../../../hooks/useAssistance/useAssistance';
import { ContentLayout } from '../../../global-styles/layout';
import NavButtons from '../../../components/nav-buttons/nav-buttons';

const Tracing = () => {
  const { t } = useTranslation(['common', 'auth', 'aa']);
  const dispatch = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [step, setStep] = useState(0);
  const { intervention, identifier } = useParams<{
    intervention?: string;
    identifier?: string;
  }>();
  const { requestIntervention } = useAssistance({ intervention });
  const navigate = useNavigate();

  const { form5: form } = useAssistanceData();

  const { data } = requestIntervention;

  useEffect(() => {
    if (data?.entidad) {
      dispatch(setProvider({ provider: data?.entidad }));
    }
  }, [data?.entidad, dispatch]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleNextStep = (customStep?: number) => {
    switch (step) {
      case 0:
        void form.handleSubmit(() => {
          const redirectTo = `/assistance/${intervention}/${identifier}`;
          storageService.setItem('assistanceUrl', redirectTo);
          navigate(redirectTo);
        })();
        break;
      default:
        break;
    }
  };

  const renderSteps = () => {
    switch (step) {
      case 0:
        return <TracingPolicy form={form} />;
      default:
        break;
    }
  };

  return (
    <>
      <ContentLayout className="with-navbar">
        <div className="register-content">{renderSteps()}</div>

        <NavButtons
          prevStep={() => null}
          showPrevButton={false}
          nextStep={() => handleNextStep()}
          nextText={t('common:buttons.next')}
        />
      </ContentLayout>
    </>
  );
};

export default Tracing;
